import { ProtectedLayout } from "@/components/layout/protected";
import { createFileRoute, Outlet } from "@tanstack/react-router";
import { ResponsiveSidebar } from "@/components/layout/sidebar";
import { ResponsiveHeader } from "@/components/layout/header";
import { AppHeader } from "@/components/dashboard/app-header";
import { ResponsiveMain } from "@/components/layout/main";

export const Route = createFileRoute("/dashboard/research/_layout")({
  component: DashboardLayout,
});

function DashboardLayout() {
  return (
    <ProtectedLayout mode="dashboard">
      <ResponsiveSidebar />
      <ResponsiveMain>
        <ResponsiveHeader>
          <AppHeader />
        </ResponsiveHeader>
        <main className="py-6 lg:py-8 flex-1 w-full overflow-y-auto">
          <div className="w-full max-w-8xl mx-auto px-4 lg:px-10">
            <Outlet />
          </div>
        </main>
      </ResponsiveMain>
    </ProtectedLayout>
  );
}
